import React, {useState, useEffect} from "react";
import AppBar from '@mui/material/AppBar';
import {
    Box,
    Toolbar,
    Typography,
    IconButton,
    Button,
    Menu,
    MenuItem,
    Container,
    Badge,
    Tooltip
} from "@mui/material";

import AppsIcon from "@mui/icons-material/Apps";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PushPinIcon from "@mui/icons-material/PushPin";
import {
  ApplicationModel,
  TabModel,
  CustomPageModel,
  ApplicationPageModel
} from "../../models/models";
import {BaseSuccessModel} from '../../models/modelsException';
import {PinModel} from '../../models/modelsUserConfiguration';
import {Link, useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import { useAuth } from "../../hooks/useAuth";
import {setSelectedTabObject,
        getSelectedTabObject} from "../../app/globalLayoutSlice";
import {upsertPin, deletePin} from "../../services/userConfigurationApi";
import {useSnackbar} from "notistack";
import {CustomIconComponent} from "../icons/CustomIcon";

export const NavigationHorizontalComponent: React.FC<{
  application: ApplicationModel,
  availableApplications: ApplicationModel[],
  tabs: TabModel[],
  customPages: CustomPageModel[],
  applicationPages: ApplicationPageModel[]
}> = (
  {
    application,
    availableApplications,
    tabs,
    customPages,
    applicationPages
  }
) => {

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const { appName, objectName, customPageName, appPageName } = useParams()
  const {accessToken, onInvalidToken} = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  const selectedTabObject = useSelector(getSelectedTabObject);
  const [selectedCustomPage, setSelectedCustomPage] = useState<CustomPageModel | null>(null);
  const [selectedAppPage, setSelectedAppPage] = useState<ApplicationPageModel | null>(null);
  //for now, hardcode custom pages

  const [isMainPin, setIsMainPin] = useState<boolean>(false);

  useEffect(() => {
    if(application.user_preference?.IsPinned_sys &&
       application.user_preference?.Rank_sys === 1){
      setIsMainPin(true)
    } else {
      setIsMainPin(false)
    }
  }, [application])

  useEffect(() => {
    if(customPageName && customPageName === 'search'){
      dispatch(setSelectedTabObject(null))
      setSelectedAppPage(null)
      setSelectedCustomPage(new CustomPageModel('CustomPage_Id_sys', 'CustomPage_Uuid_sys', 'search', 'Search'))
    }
  }, [customPageName])

  useEffect(() => {
    if(appPageName){
      dispatch(setSelectedTabObject(null))
      setSelectedCustomPage(null)
      const thisAppPage = applicationPages.find((appPage: ApplicationPageModel) => appPage.ApiName_sys===appPageName)
      if(thisAppPage) setSelectedAppPage(thisAppPage)
    }
  }, [appPageName, availableApplications.length])


  const getApplicationURL = () => {
    let url = '/';
    if(application !== null){
      url = `/${application.ApiName_sys}`;
    }
    return url
  }

  const selectPage = (objectApiName: string) => {
    setAnchorElNav(null);
    dispatch(setSelectedTabObject(objectApiName));
    setSelectedCustomPage(null);
    setSelectedAppPage(null);
    navigate(objectApiName);
  }

  const selectCustomPage = (customPage: CustomPageModel) => {
    setAnchorElNav(null);
    dispatch(setSelectedTabObject(null));
    setSelectedCustomPage(customPage)
    setSelectedAppPage(null)
    navigate(`customPage/${customPage.ApiName_sys}`);
  }

  const selectAppPage = (appPage: ApplicationPageModel) => {
    setAnchorElNav(null);
    dispatch(setSelectedTabObject(null));
    setSelectedCustomPage(null);
    setSelectedAppPage(appPage)
    navigate(`appPage/${appPage.ApiName_sys}`);
  }

  const selectApplication = (app: ApplicationModel) => {
    setAnchorElApps(null);
    dispatch(setSelectedTabObject(null));
    setSelectedCustomPage(null)
    setSelectedAppPage(null)
    navigate(`/${app.ApiName_sys}`);
  }


  //anchor elements for drop-down menues (i.e., for app list, and for navigation menu)
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElApps, setAnchorElApps] = React.useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenAppsMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElApps(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseAppsMenu = () => {
    setAnchorElApps(null);
  };


  const handleAppPin = () => {

    const thisObjectName = 'Application_mdt';
    if(isMainPin){
      deletePin(accessToken, thisObjectName, application.Uuid_sys)
        .then((thisSuccess: BaseSuccessModel) => {
           enqueueSnackbar(thisSuccess.message, {
             variant: "success",
           });
           //onChange(listView)
           setIsMainPin(false)
        })
        .catch((err) => {
           enqueueSnackbar(err.message, {
             variant: "error",
           });
        })
    } else {
      upsertPin(accessToken, thisObjectName, application.Uuid_sys)
        .then((thisPin: PinModel) => {
           enqueueSnackbar("Application has been pinned", {
             variant: "success",
           });
           setIsMainPin(true)
           //onChange(listView)
        })
        .catch((err) => {
           enqueueSnackbar(err.message, {
             variant: "error",
           });
        })
      }
    }

  const getRank = () => {
    if(application.user_preference &&
       application.user_preference.IsPinned_sys){
         return application.user_preference?.Rank_sys
       }
    return null
  }


  //navigation bar element (i.e., objects)
  const navBarTabElement = (tab: TabModel) => {
    const getRank = () => {
      if(tab.user_preference &&
         tab.user_preference.IsPinned_sys){
           return tab.user_preference?.Rank_sys
         }
      return null
    }

    let buttonSubClass = {my: 2,
                          color: "white",
                          display: "block",
                          backgroundColor: "inherit",
                          borderBottom: "none",
                          borderRadius: 0};

    if(selectedTabObject === tab.ReferencedObject_sys.ApiName_sys){
      buttonSubClass.borderBottom = "5px solid black"
    }

    return (
      <Box key={tab.Uuid_sys}>
        <Button
          variant="contained"
          sx={buttonSubClass}
          fullWidth
          onClick={() => selectPage(tab.ReferencedObject_sys.ApiName_sys)}
        >
          <Typography
            color="textPrimary"
            style={{
              marginTop: 2,
              marginBottom: 2 }}
          >
            {tab.ReferencedObject_sys.PluralLabel_sys}
          </Typography>
        </Button>
      </Box>
    )
  }


  //navigation bar element (i.e., objects)
  const navBarCustomPageElement = (customPage: CustomPageModel) => {

    let buttonSubClass = {my: 2,
                          color: "white",
                          display: "block",
                          backgroundColor: "inherit",
                          borderBottom: "none",
                          borderRadius: 0};

    if(customPage.ApiName_sys === selectedCustomPage?.ApiName_sys){
      buttonSubClass.borderBottom = "5px solid black"
    }

    return (
      <Box key={customPage.ApiName_sys}>
        <Button
          variant="contained"
          sx={buttonSubClass}
          fullWidth
          onClick={() => selectCustomPage(customPage)}
        >
          <Typography
            color="textPrimary"
            style={{
              marginTop: 2,
              marginBottom: 2,
              fontStyle: 'italic'
            }}
          >
            {customPage.Label_sys}
          </Typography>
        </Button>
      </Box>
    )
  }

  //navigation bar element (i.e., objects)
  const navBarAppPageElement = (appPage: ApplicationPageModel) => {

    let buttonSubClass = {my: 2,
                          color: "white",
                          display: "block",
                          backgroundColor: "inherit",
                          borderBottom: "none",
                          borderRadius: 0};

    if(appPage.ApiName_sys === selectedAppPage?.ApiName_sys){
      buttonSubClass.borderBottom = "5px solid black"
    }

    return (
      <Box key={appPage.ApiName_sys}>
        <Button
          variant="contained"
          sx={buttonSubClass}
          fullWidth
          onClick={() => selectAppPage(appPage)}
        >
          <Typography
            color="textPrimary"
            style={{
              marginTop: 2,
              marginBottom: 2,
              fontStyle: 'italic'
            }}
          >
            {appPage.Label_sys}
          </Typography>
        </Button>
      </Box>
    )
  }


  const navMenuTabElement = (tab: TabModel) => {

    return (
      <MenuItem
         key={tab.ReferencedObject_sys.PluralLabel_sys}
         onClick={() => selectPage(tab.ReferencedObject_sys.ApiName_sys)}
         sx={{
           justifyContent: 'space-between'
         }}
      >
         <Typography
            sx={{
              textAlign: 'center'
            }}
         >
           {tab.ReferencedObject_sys.PluralLabel_sys}
         </Typography>

      </MenuItem>
    )
  }

  const navMenuCustomPageElement = (customPage: CustomPageModel) => {

    return (
      <MenuItem
         key={customPage.ApiName_sys}
         onClick={() => selectCustomPage(customPage)}
         sx={{
           justifyContent: 'space-between'
         }}
      >
         <Typography
            sx={{
              textAlign: 'center',
              fontStyle: 'italic'
            }}
         >
           {customPage.Label_sys}
         </Typography>

      </MenuItem>
    )
  }

  const navMenuAppPageElement = (appPage: ApplicationPageModel) => {

    return (
      <MenuItem
         key={appPage.ApiName_sys}
         onClick={() => selectAppPage(appPage)}
         sx={{
           justifyContent: 'space-between'
         }}
      >
         <Typography
            sx={{
              textAlign: 'center',
              fontStyle: 'italic'
            }}
         >
           {appPage.Label_sys}
         </Typography>

      </MenuItem>
    )
  }


  const appMenuElement = (app: ApplicationModel) => {
      /** remove tooltip
      <Tooltip
         key={app.Uuid_sys}
         title={app.Description_sys}
      >
      </Tooltip>
      **/

    return (

        <MenuItem
           key={app.Uuid_sys}
           onClick={() => selectApplication(app)}
           sx={{
             justifyContent: 'space-between'
           }}
        >
          <Box sx={{display: 'flex',
                    flexDirection: 'row',
                    gap: 1,
                    alignItems: 'center'}}
          >
            {app.ReferencedIcon_sys &&
             <CustomIconComponent
                icon={{...app.ReferencedIcon_sys,
                       Colour_sys: 'text.secondary'}}
                sx={{
                  fontWeight: 500,
                }}
             />}
            <Typography
              sx={{ textAlign: 'center' }}
            >
              {app.Label_sys}
            </Typography>
          </Box>
         {app.user_preference?.IsPinned_sys &&
         <IconButton
           size="small"
           onClick={() => {}}
           disabled
         >
           <Badge badgeContent={app.user_preference?.IsPinned_sys ? app.user_preference?.Rank_sys : null}>
             <PushPinIcon fontSize="small"/>
            </Badge>
          </IconButton>
        }
        </MenuItem>
    )
  }


  return (
    <Toolbar>
      <Container maxWidth="xl">
        <Toolbar disableGutters>

          {/*AppsIcon in navigation bar*/}
          <Box
            sx={{
              display: {xs: 'none', md: 'flex' },
              mr: 1
            }}
          >
            <Tooltip title="Open Applications">
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={handleOpenAppsMenu}
            >
               <AppsIcon />
            </IconButton>
            </Tooltip>

            <Menu
              id="menu-apps"
              anchorEl={anchorElApps}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElApps)}
              onClose={handleCloseAppsMenu}
              sx={{ display: { xs: 'block', md: 'block' } }}
            >
            {availableApplications.map((thisApplication) => appMenuElement(thisApplication))}
            </Menu>


          </Box>


          {/*Application Home Link in navigation bar*/}
          <Box
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' }
            }}
          >
            <Typography variant="h6">

              <Tooltip title={application?.Description_sys}>
                <Link
                  to={getApplicationURL()}
                  onClick={() => setSelectedTabObject(null)}
                >
                  {application?.Label_sys}
                </Link>
              </Tooltip>

              <Tooltip key={'application-pin'} title={isMainPin ? 'Unpin Application': 'Pin Application'}>
                <IconButton
                  size="small"
                  onClick={() => handleAppPin()}
                  color={isMainPin ? 'primary': 'default'}
                  sx={{verticalAlign: 'super'}}
                >
                  <Badge badgeContent={getRank()}>
                    <PushPinIcon fontSize="small"/>
                  </Badge>
                </IconButton>
              </Tooltip>

            </Typography>

          </Box>

          {/*All Tab Elements in navigation bar*/}
          <Box
            sx={{ flexGrow: 1,
                  display: { xs: 'none', md: 'flex' },
                  flexWrap: "wrap"
                }}
          >
            {applicationPages.map((appPage) => navBarAppPageElement(appPage))}

            {tabs.map((tab) => navBarTabElement(tab))}

            {customPages.map((customPage) => navBarCustomPageElement(customPage))}

          </Box>



          {/*AppsIcon in navigation bar*/}
          <Box
            sx={{
              display: {xs: 'flex',
                        md: 'none'}
            }}
          >
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={handleOpenAppsMenu}
            >
               <AppsIcon />
            </IconButton>
          </Box>

          {/*Application Home Link in navigation bar*/}
          <Box
            sx={{
              display: { xs: 'flex', md: 'none' }
            }}
          >
            <Link
              to={getApplicationURL()}
              onClick={() => setSelectedTabObject(null)}
            >
              <Typography
                    variant="h6"
              >
                 {application?.Label_sys}
              </Typography>
            </Link>
          </Box>



          {/*All Tab Elements as drop-down menu*/}
          <Box
            sx={{
              justifyContent: "flex-end",
              display: { xs: 'flex', md: 'none' }
            }}
          >

            <IconButton
              size="large"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <ArrowDropDownIcon />
            </IconButton>

            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
            {applicationPages.map((appPage) => navMenuAppPageElement(appPage))}
            {tabs.map((tab) => navMenuTabElement(tab))}
            {customPages.map((customPage) => navMenuCustomPageElement(customPage))}
            </Menu>
          </Box>



        </Toolbar>
      </Container>
    </Toolbar>
  );
}
